module.exports = __webpack_public_path__ + "img/square-table-4.ef665be0.png";